import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';
import ElementInfoCardsImage from '../../images/ElementInfoCards.png';

class ElementInfoCards extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Elements Information Card</Popover.Title>
                <Popover.Content>
                    <img src={ElementInfoCardsImage} className="popover-images" alt="Element Info Cards" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-alpha" style={this.props.positioning}>
                    <GeoAltFill alt="Element Info Cards Clue" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default ElementInfoCards
